module.exports = "/packs/cal-chevron-left-cbb4cfb593c30275d6a44bb08572db86.svg";